import { getMarketByName, MARKETS } from './markets'
import { round2 } from './money'

// Aircon high ceiling (tall ladder needed).
//
// Deliberately not a booking question: almost every home has a normal ceiling,
// so the booking step only shows a passive "Ceiling: Normal · Change" line, and
// the Confirm Details sheet after payment asks it properly. Either answer is
// saved by the backend (AirconService.setHighCeiling), which adds the
// "High ceiling - tall ladder" line item at its own price: in the booking price
// when chosen before payment, on the partner's final bill when chosen after.
// Everything here is display only.

// Criteria code sent with the booking; codes 21-27 are the other aircon answers
export const HIGH_CEILING_CODE = 28

// Same name as the backend's item (AirconService.HIGH_CEILING_ITEM), so a
// partner adding it on site matches one the customer chose
export const HIGH_CEILING_ITEM = 'High ceiling - tall ladder'

// /UploadRequest saves an entry's "criteria", /UploadRequestWithServiceItems
// (the aircon picker) its "itemName", so the line carries both
const HIGH_CEILING_TEXT = 'Ceiling height - High (tall ladder needed)'
export const HIGH_CEILING_CRITERIA = {
    [HIGH_CEILING_CODE]: 'High',
    criteria: HIGH_CEILING_TEXT,
    itemName: HIGH_CEILING_TEXT,
}

// The booking's criteria with the high-ceiling answer set (or removed)
export const withHighCeiling = (requestCriteria, isHighCeiling) => {
    const others = (requestCriteria || []).filter((c) => c?.[HIGH_CEILING_CODE] === undefined)
    return isHighCeiling ? [...others, HIGH_CEILING_CRITERIA] : others
}

export const hasHighCeiling = (requestCriteria) =>
    (requestCriteria || []).some((c) => c?.[HIGH_CEILING_CODE] === 'High')

// A displayed booking price with the surcharge added (extra = 0 leaves it as is)
export const addHighCeiling = (cost, extra) =>
    (extra > 0 && cost ? round2(Number(cost) + extra) : cost)

export const ceilingMarket = (countryName) => getMarketByName(countryName) ?? MARKETS.sg

// For a job, whose model carries its currency rather than its country
export const ceilingMarketByCurrency = (currencyCd) =>
    Object.values(MARKETS).find((m) => m.currency === currencyCd) ?? MARKETS.sg

// Visits the per-visit surcharge applies to: the annual package count
// (criteria 23, e.g. 3 or "3 times/year"), else one.
export const visitsFromCriteria = (requestCriteria) => {
    for (const c of requestCriteria || []) {
        const visits = parseInt(c?.[23], 10)
        if (visits > 0) return visits
    }
    return 1
}

// What choosing High adds to the booking total: the surcharge per visit plus the
// category's convenience fee on it (ServiceCostService.addItemCost). Never discounted.
export const highCeilingExtra = (market, visits = 1, serviceChargePercent = 0) => {
    const fee = round2((market?.highCeilingSurcharge || 0) * visits)
    return round2(fee + (serviceChargePercent > 0 ? round2(fee * serviceChargePercent / 100) : 0))
}
